import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/blog/LegacyBlogRedirect.tsx");
